import { pushPath } from './routesUtils';
import { libreRequestRoute, newRequestRoute, requestRoute } from './shortLinks';

export const getShortActiveRoute = (url = '') => {
    if (url.startsWith('/l-')) {
        return pushPath([libreRequestRoute], []);
    } else if (url.startsWith('/b-')) {
        return pushPath([requestRoute], []);
    } else if (url.startsWith('/new/b-')) {
        return pushPath([newRequestRoute], []);
    }
};
